<div class="full-text-header">
  <a id="go-back" (click)="windowClose()">
    <mat-icon>arrow_back</mat-icon>
    Back to Portfolio
  </a>
  <span class="full-text-title"> Full Text for "{{ trademarkName }}" </span>
</div>
